var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.143 489.143",
    style: {
      enableBackground: "new 0 0 489.143 489.143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4C8F5"
    },
    points: "85.924,272.426 48.7,329.482 159.674,440.457 216.73,403.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4C8F5"
    },
    points: "114.551,106.303 17.164,203.69 94.942,228.465 222.331,101.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A7ADF0"
    },
    points: "285.465,471.992 382.853,374.605 388.081,266.818 260.69,394.208  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.155,
    y: 350.18,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 273.7352 87.5724)",
    style: {
      fill: "#FFB655"
    },
    width: 40.001,
    height: 48.083
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.934,
    y: 433.959,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -127.6436 863.1308)",
    style: {
      fill: "#FF9811"
    },
    width: 40.001,
    height: 48.083
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.795,
    y: 403.425,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -280.5937 169.442)",
    style: {
      fill: "#FFB655"
    },
    width: 70.884,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#165C92"
    },
    d: "M477.223,23.582l-3.196-8.457L403.84,85.312c19.53,19.53,19.523,51.188,0,70.711 c-19.53,19.53-51.18,19.53-70.711,0L151.325,337.827l82.873,82.873l200.74-200.741C486.288,168.61,502.884,91.528,477.223,23.582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96C8EF"
    },
    d: "M403.84,156.023c19.523-19.523,19.53-51.18,0-70.711l-70.711,70.711 C352.659,175.553,384.31,175.553,403.84,156.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1E81CE"
    },
    d: "M333.129,156.023c-19.523-19.523-19.53-51.18,0-70.711c19.523-19.523,51.188-19.523,70.711,0 l70.187-70.187l-8.45-3.189C444.612,4.009,422.571,0,400.085,0c-49.441,0-95.926,19.247-130.885,54.207L68.452,254.954 l82.873,82.873L333.129,156.023z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1E7F8"
    },
    d: "M333.129,85.312c-19.53,19.53-19.523,51.188,0,70.711l70.711-70.711 C384.317,65.789,352.652,65.789,333.129,85.312z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.a456f8b44821a1f0b333024602b97a03.svg";
export { ForwardRef as ReactComponent };